// The browser's IANA zone, sent as X-Time-Zone so the server knows the person's local time.
export function browserTimeZone(): string | null {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || null
  } catch {
    return null
  }
}
